export const ENVIRONMENTS_REQUEST = 'ENVIRONMENTS_REQUEST';

export const FETCH_ENVIRONMENTS_LIST_SUCCESS =
  'FETCH_ENVIRONMENTS_LIST_SUCCESS';
export const FETCH_ENVIRONMENTS_LIST_ERROR = 'FETCH_ENVIRONMENTS_LIST_ERROR';

export const CREATE_ENVIRONMENT_SUCCESS = 'CREATE_ENVIRONMENT_SUCCESS';
export const CREATE_ENVIRONMENT_ERROR = 'CREATE_ENVIRONMENT_ERROR';

export const DELETE_ENVIRONMENT_SUCCESS = 'DELETE_ENVIRONMENT_SUCCESS';
export const DELETE_ENVIRONMENT_ERROR = 'DELETE_ENVIRONMENT_ERROR';

export const EDIT_ENVIRONMENT_SUCCESS = 'EDIT_ENVIRONMENT_SUCCESS';
export const EDIT_ENVIRONMENT_ERROR = 'EDIT_ENVIRONMENT_ERROR';
